<div class="project__cart-donations" *ngIf="actionsVisibility">
  <div class="inputs--donation" [ngClass]="eventCategory ? 'inputs--donation-ukraine' : ''">
    <app-ph-input
      type="radio"
      #cartRadios
      [validation]="'base'"
      name="donate"
      [correctForm]="form"
      [initValue]="initValue"
      (phInputChange)="changeDonateRadio($event)"
    >
      <app-ph-radio
        *ngFor="let btn of donatesButtons"
        name="donate"
        [value]="btn.val"
        [ngClass]="{
          hidden: btn.currency !== currencyPicked
        }"
      >
        <span
          class="btn btn--md btn--square"
          [ngClass]="{
            'btn--primary': form.value.donate === btn.val,
            'btn--square-sm': buttonSmall,
            'btn--outline': form.value.donate !== btn.val
          }"
          >{{ btn.val }} {{ currencyPicked | currencyFormatter }}</span
        >
      </app-ph-radio>
    </app-ph-input>
    <app-ph-input
      type="number"
      class=""
      [ngClass]="eventCategory ? 'project__cart-donations--number' : ''"
      [placeholder]="
        eventCategory
          ? ('PROJECT.amount' | translate)
          : ('PROJECT.amount' | translate) + ' (max. ' + Config.MAXIMAL_PAY_COUNT + ')'
      "
      [validation]="'donate'"
      name="donate"
      [correctForm]="form"
      [initValue]="initValueInput"
      (keyUpEnter)="changeDonateInput(currentValueSetDonate)"
      (phInputChange)="saveSetValue($event)"
    >
    </app-ph-input>
  </div>
  <div class="inputs--currency-submit">
    <app-ph-input
      type="select"
      class="select--top"
      [placeholder]="'PROJECT.currency' | translate"
      [validation]="'base'"
      bindValue="curr"
      name="currentCurrency"
      [searchable]="false"
      [clearable]="false"
      [selectArray]="availableOperatorsList"
      [dropdownPosition]="'top'"
      bindLabel="name"
      [correctForm]="form"
      (phInputChange)="currencyChanged($event)"
      [initValue]="currencyPicked"
    ></app-ph-input>
    <button class="btn btn--primary btn--md btn--donate" (click)="clearCartAndAddOneItem()">
      {{ 'PROJECT.donate' | translate }}
    </button>
    <ng-container
      *ngIf="
        project.status !== enumProjectStatus.DRAFT && project.status !== enumProjectStatus.AWAITING
      "
    >
      <button
        *ngIf="eventCategory"
        (click)="openModal('email-send')"
        class="btn btn--outline btn--md btn--primary ukraine-help-button"
      >
        {{ 'PROJECT.offer_your_help' | translate }}
      </button>
    </ng-container>
  </div>
</div>

<p-dialog
  *ngIf="displayContactModal"
  [(visible)]="displayContactModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayContactModal = false"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <app-contact-form
      [project]="project"
      [ukrainianEvent]="eventCategory"
      (closeModalEmitter)="displayContactModal = false"
    ></app-contact-form>
  </div>
</p-dialog>
